import { css } from '@emotion/react';

export const styFormInputContainer = css({
  marginBottom: '32px',
});
